"use client";
import { UseDisclosureReturn } from "@chakra-ui/react";
import {
  createContext,
  type Dispatch,
  type MutableRefObject,
  type PropsWithChildren,
  type SetStateAction,
} from "react";
import { type RscRouterParameters } from "../hooks/rsc-router-params";
import { usePlaceSearch } from "../hooks/use-place-search";

export interface PlaceSearchContextType extends RscRouterParameters {
  modal: Pick<UseDisclosureReturn, "isOpen" | "onOpen" | "onClose">;
  onKeyDown: (e: any) => void;
  results: any[];
  active: number;
  onMouseSetActive: (num: number) => void;
  query: string;
  setQuery: Dispatch<SetStateAction<string>>;
  redirectResult: () => void;
  resultMenuRef: MutableRefObject<HTMLDivElement | null>;
  resultRefs: MutableRefObject<Array<HTMLDivElement | null>>;
}

export const PlaceSearchContext = createContext<PlaceSearchContextType | null>(
  // Necessary for type checking.
  // As per React docs, default not used when context is used with provider
  null,
);

export function PlaceSearchProvider({
  children,
  router,
  rsc,
}: PropsWithChildren<RscRouterParameters>) {
  const value = usePlaceSearch({ router, rsc });

  return (
    <PlaceSearchContext.Provider value={value}>
      {children}
    </PlaceSearchContext.Provider>
  );
}
